module.exports = __webpack_public_path__ + "images/digital-content-5edd7ac9.svg";